export default "__VITE_ASSET__D$DthHPb__"